import { GlobalConstants } from "../../data/GlobalConstants";
import { handleResponse } from "../../util/functions";
import { getToken } from "../../helpers/helperJWT";
import { loaderService } from "../loaderService";

const url = GlobalConstants.urlApi;

const getDataGrupos = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/gruposImpulsar/getDataGrupos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updateStateGrupo = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/gruposImpulsar/updateStateGrupo`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const deleteGrupoImpulsar = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/gruposImpulsar/deleteGrupoImpulsar`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updateGrupo = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/gruposImpulsar/updateGrupo`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const saveGrupo = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/gruposImpulsar/saveGrupo`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getProductosImpulsar = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/gruposImpulsar/getProductosImpulsar`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getProductosImpulsarDisponibles = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/gruposImpulsar/getProductosImpulsarDisponibles`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const saveProductosGrupo = (data) => {
    loaderService.showLoader({ label: "Cargando..." });
    
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/gruposImpulsar/saveProductosGrupo`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const validarExcelProductos = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/gruposImpulsar/validarExcelProductos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

export const gruposImpulsarService = {
    getDataGrupos,
    updateStateGrupo,
    deleteGrupoImpulsar,
    updateGrupo,
    saveGrupo,
    getProductosImpulsar,
    getProductosImpulsarDisponibles,
    saveProductosGrupo,
    validarExcelProductos
};